import axios from 'axios';

const client = axios.create({
  //baseURL: 'http://localhost:8080/',
  timeout: 180000,
  withCredentials: false,
});

client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    const user = localStorage.getItem('user');
    //let targetUrl = 'http://127.0.0.1:8080/api';

    if (token) {
      //console.log('Bearer ' + JSON.parse(token));
      config.headers['Authorization'] = 'Bearer ' + JSON.parse(token);
    }
    if (user) {
      // 로그인하면 해당하는 url 에 따라야 함.
      const jsonUser = JSON.parse(user);
      config.headers['companyCd'] = jsonUser.companyCd;
    }
    // config.headers['x-target-base-endpoint'] = targetUrl;
    config.headers['Content-Type'] = 'application/json';

    // console.log(config.headers, 'config.headers');
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log('client.js', error);
    if (error.response.status === 401 || error.response.status === 504) {
      // dispatch something to your store
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    // if (error) {
    //   // dispatch something to your store
    //   localStorage.removeItem('access_token');
    //   localStorage.removeItem('user');
    //   window.location.href = '/login';
    // }

    return Promise.reject(error);
  },
);

export default client;
